import React, { useEffect, useState } from 'react';
import { Input } from '@blueprintnyc/bpnyc-common';
import ColorInput from 'components/ColorInput';
import ImageUpload from 'components/ImageUpload';
import config from 'config';

const WidgetBuilderSettings = props => {
	const { theme, setTheme, event, pageName, setPageName, setHasChanges } = props;
	const { brandPrimary } = event.theme;

	const defaultBg = '#FFFFFF';
	const defaultWidget = brandPrimary || '#000000';

	const [backgroundColor, setBackgroundColor] = useState(theme.background_color || defaultBg);
	const [widgetsColor, setWidgetsColor] = useState(theme.widgets_color || defaultWidget);

	useEffect(() => {
		setTheme({
			...theme,
			background_color: backgroundColor,
			widgets_color: widgetsColor,
		});
	}, [backgroundColor, widgetsColor]);

	const signedUrlEndpoint = `${config.baseUrl}/${event.client_id}/events/${event.id}/upload/media/signed_url`;

	const handlePickMedia = src => {
		setTheme({ ...theme, background_src: src });
	};

	const handleChange = (val, fn) => {
		fn(val);
		setHasChanges(true);
	};

	return (
		<div className="WidgetBuilderSettings">
			<span className="header-text">Page Settings</span>
			<div className="settings">
				{pageName ? (
					<div className="form-item">
						<h4 className="admin-form-item-label">Page Name</h4>
						<Input value={pageName} onChange={name => handleChange(name, setPageName)} />
					</div>
				) : null}
				<div className="row">
					<div className="form-item">
						<h4 className="admin-form-item-label">Background Image</h4>
						<ImageUpload
							endpoint={signedUrlEndpoint}
							value={theme && theme.background_src}
							onChange={src => handleChange(src, handlePickMedia)}
							name="background-image"
						/>
					</div>
					<div className="ColorPickers">
						<div className="ColorPicker">
							<h4 className="admin-form-item-label">Background Color</h4>
							<ColorInput
								color={backgroundColor}
								eventID={event.id}
								onChange={e => {
									e
										? handleChange(e, setBackgroundColor)
										: setTimeout(() => setBackgroundColor(defaultBg), 1500);
								}}
								defaultColor={defaultBg}
							/>
						</div>
						<div className="ColorPicker">
							<h4 className="admin-form-item-label">Widget Accent Color</h4>
							<ColorInput
								color={widgetsColor}
								eventID={event.id}
								onChange={e => {
									e
										? handleChange(e, setWidgetsColor)
										: setTimeout(() => setWidgetsColor(defaultWidget), 1500);
								}}
								defaultColor={defaultWidget}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default WidgetBuilderSettings;
